import React, { useState, useEffect } from "react";
import { Box, Button, IconButton, Modal, Slide, TextField, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { addDoc, collection, updateDoc } from "firebase/firestore";
import { useAuth } from "../../contexts/AuthContext";
import { showCustomToast } from "../Misc/CustomToast";
import DatePickerWithTimeComponentNoTitle from "../Misc/DatePickerWithTimeComponentNoTitle";
import UploaderDocForNoteV2 from "../Updloader/UploaderDocForNoteV2";
import InputComponentNoTitleNomargin from "../inputs/InputComponentNoTitleNomargin";
import DropDownComponentSortedNoTitle from "../DropDownComponentSortedNoTitle";
import { db } from "../../firebase";
import DatePickerWithTimeComponentNoTitleNoMargin from "../Misc/DatePickerWithTimeComponentNoTitleNoMargin";
import SearchBarInModal from "../Misc/SearchBarInModal";
import SmallClientChipV3Large from "../Misc/SmallClientChipV3Large";
import DropDownSpecificStaffV2 from "../Dropdowns/DropDownSpecificStaffV2";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";

const NotesAddModal = ({
  open,
  onClose,
  noteType,
  handleSave,
  clientFirstName,
  clientLastName,
  clientPic,
  isMobile,
}) => {
  const { currentUser } = useAuth();
  const [noteContent, setNoteContent] = useState("");
  const [effectiveDateTime, setEffectiveDateTime] = useState(null);
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Example state for a specific note type
  const [shiftStartRaw, setShiftStartRaw] = useState(null);
  const [shiftEndRaw, setShiftEndRaw] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState("");
  const [groupTopic, setGroupTopic] = useState("");
  const [groupType, setGroupType] = useState("");
  const [otherTypeGroupNote, setOtherTypeGroupNote] = useState("");
  const [notInAttendance, setNotInAttendance] = useState("");
  const [immmigrationAppointment, setImmigrationAppointment] = useState("");
  const [dischargesSwot, setDischargeSwot] = useState("");
  const [newClients, setNewClients] = useState("");
  const [medicalInfos, setMedicalInfos] = useState("");
  const [hospitalAppointment, setHospitalAppointment] = useState("");
  const [residentialClientMovements, setResidentialClientMovements] =
    useState("");
  const [zoomSessionAssistance, setZoomSessionAssistance] = useState("");
  const [staffToday, setStaffToday] = useState("");
  const [overnight, setOvernight] = useState("");
  const [numberOfClient, setNumberOfClient] = useState("");
  const [swot, setSwot] = useState("");
  const [generalAnnouncement, setGeneralAnnouncement] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);
  const [errors, setErrors] = useState({});

  const validateFields = () => {
    const newErrors = {};

    switch (noteType) {
      case "aftercareNote":
      case "medicalNote":
      case "quickNote":
      case "supportStaffNote":
      case "therapyNote":
        if (!selectedClient) newErrors.clientName = "Client Name Required";
        if (!noteContent) newErrors.noteContent = "Content Required";
        if (!effectiveDateTime)
          newErrors.effectiveDateTime = "Effective Date Required";
        break;
      case "handoverNote":
        if (!immmigrationAppointment)
          newErrors.immigrationAppointment = "Immigration Appointment Required";
        if (!dischargesSwot)
          newErrors.dischargesSwot = "Discharges Flights Required";
        if (!newClients) newErrors.newClients = "New Clients Required";
        if (!medicalInfos)
          newErrors.medicalInfos = "Psychiatrist Appointments Required";
        if (!hospitalAppointment)
          newErrors.hospitalAppointment = "Hospital Appointments Required";
        if (!residentialClientMovements)
          newErrors.residentialClientMovements = "OutingsRequired";
        if (!zoomSessionAssistance)
          newErrors.zoomSessionAssistance = "Zoom Session Assistance Required";
        if (!staffToday) newErrors.staffToday = "Staff Today Required";
        if (!overnight) newErrors.overnight = "Overnight Required";
        if (!numberOfClient)
          newErrors.numberOfClient = "Number Of Clients Required";
        if (!swot) newErrors.swot = "Swot Required";
        if (!generalAnnouncement)
          newErrors.generalAnnouncement = "General Announcement Required";
        if (!effectiveDateTime)
          newErrors.effectiveDateTime = "Effective Date Required";
        break;
      case "groupNote":
        if (!groupTopic) newErrors.groupTopic = "Group Topic Required";
        if (!effectiveDateTime)
          newErrors.effectiveDateTime = "Group Start Time Required";
        if (!groupType) newErrors.groupType = "Group Type Required";
        if (!noteContent) newErrors.noteContent = "Content Required";
        if (!notInAttendance)
          newErrors.notInAttendance = "Not In Attendance Required";
        break;
      case "endOfShift":
        if (!noteContent) newErrors.noteContent = "Content Required";
        if (!shiftStartRaw) newErrors.shiftStartRaw = "Start Of Shift Required";
        if (!shiftEndRaw) newErrors.shiftEndRaw = "End Of Shift Required";
        if (!selectedStaff) newErrors.selectedStaff = "Staff Required";
        if (!effectiveDateTime)
          newErrors.effectiveDateTime = "Effective Date Required";
        break;
      case "familyNote":
        if (!selectedClient) newErrors.clientName = "Client Name Required";
        if (!noteContent) newErrors.noteContent = "Content Required";
        if (!effectiveDateTime)
          newErrors.effectiveDateTime = "Effective Date Required";
        if (files.length === 0) newErrors.files = "File is required"; // Si nécessaire
        break;

      default:
        break;
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      showCustomToast("Please Fill All Required Fields", "error");
    }

    return Object.keys(newErrors).length === 0;
  };


  // Gestionnaire de changement pour shiftEnd

  // Gestionnaire de changement pour le personnel


  const handleFilesChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.every((file) => file.size <= 50 * 1024 * 1024)) {
      setFiles(selectedFiles);
    } else {
      alert("One or more files exceed the size limit of 50MB.");
    }
  };


  const handleFileRemove = (fileName) => {
    setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
  };

  const renderModalContent = (noteType, shouldShowClientSearch) => {
    const renderClientSection = () => (
      <div>
        <div
          style={{
            width: "70%",
            marginTop: "20px",
            display: "flex",
            paddingLeft: "20px",
          }}
        >
          <SearchBarInModal setSelectedClient={setSelectedClient} />
        </div>

        {selectedClient ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              paddingTop: "20px",
            }}
          >
            <div
              style={{ paddingLeft: "20px", color: "black", fontWeight: "600" }}
            >
              Selected Client
            </div>
            <div
              style={{
                width: "70%",
                marginTop: "10px",
                display: "flex",
                paddingLeft: "20px",
                justifyContent: "flex-start",
                border: selectedClient
                  ? "1px solid lightgray"
                  : "1px solid red",
                borderRadius: "10px",
                marginLeft: "20px",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
            >
              <SmallClientChipV3Large
                firstName={selectedClient.firstName}
                lastName={selectedClient.lastName}
                avatar="1"
                clientPic={selectedClient.profilePicture}
              />
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              paddingTop: "20px",
              paddingLeft: "25px",
            }}
          >
            <div style={{ color: "black", fontWeight: "600" }}>
              {"No Client Selected"}
            </div>
            {errors.clientName && (
              <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                {errors.clientName}
              </div>
            )}
          </div>
        )}
      </div>
    );

    const renderNoteContent = (placeholder, rows) => (
      <div className="line2-column-modal">
        <div
          className="label-textfield-handover"
          style={{
            color: "black",
            fontWeight: "600",
            paddingLeft: "15px",
            paddingBottom: "5px",
          }}
        >
          Note Content
        </div>
        <TextField
          value={noteContent}
          onChange={(e) => setNoteContent(e.target.value)}
          style={{
            width: "95%",
            borderRadius: "5px",
          }}
          placeholder={placeholder}
          multiline
          rows={rows}
          error={!!errors.noteContent} // Highlight the input if there's an error
          helperText={errors.noteContent}
        />
      </div>
    );

    const renderEffectiveDateTime = () => (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        <div
          className="label-textfield-handover"
          style={{
            color: "black",
            fontWeight: "600",
            marginTop: "20px",
            paddingLeft: "20px",
            paddingBottom: "5px",
          }}
        >
          Effective Date Time
        </div>
        <div style={{ paddingLeft: "15px" }}>
          <DatePickerWithTimeComponentNoTitle
            title="Effective Date Time"
            value={effectiveDateTime}
            onChange={(date) => setEffectiveDateTime(date)}
            error={!!errors.effectiveDateTime}
            helperText={errors.effectiveDateTime}
          />
        </div>
      </div>
    );


    switch (noteType) {
      case "supportStaffNote":
        return (
          <div>
            {renderClientSection()}
            <div style={{ width: "100%", marginTop: "0px", height: "100%" }}>
              {renderNoteContent("Type Note Here", 14)}
              {renderEffectiveDateTime()}
            </div>
          </div>
        );

      case "endOfShift":
        return (
          <div>
            <div
              className="line2-column-modal-slider"
              style={{ paddingLeft: "25px" }}
            >
              <div
                // className="label-textfield"
                style={{
                  color: "black",
                  fontWeight: "600",
                  marginTop: "10px",
                  paddingBottom: "5px",
                }}
              >
                {"Note Content"}
              </div>
              <TextField
                value={noteContent}
                onChange={(e) => setNoteContent(e.target.value)}
                style={{
                  width: "95%",
                  borderRadius: "5px",
                  // backgroundColor: "#f2eeef",
                }}
                placeholder={"Type Note Here"}
                multiline
                rows={12}
                error={!!errors.noteContent} // Highlight the input if there's an error
                helperText={errors.noteContent}
              />
            </div>
            <div
              // className="line3-modal-mobile-bis"
              style={{
                display: "flex",
                flexDirection: "row",
                paddingLeft: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignContent: "flex-start",
                  alignItems: "flex-start",
                  alignSelf: "flex-start",
                  marginTop: "10px",
                }}
              >
                <div
                  // className="label-textfield"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    marginTop: "10px",
                    paddingLeft: "15px",
                    textAlign: "start",
                  }}
                >
                  Start Of Shift
                </div>
                <div style={{ paddingLeft: "5px" }}>
                  <DatePickerWithTimeComponentNoTitle
                    value={shiftStartRaw}
                    onChange={(date) => setShiftStartRaw(date)}
                    title="Start Of Shift"
                    error={!!errors.shiftStartRaw}
                    helperText={errors.shiftStartRaw}
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignContent: "flex-start",
                  alignItems: "flex-start",
                  alignSelf: "flex-start",
                  marginTop: "10px",
                  marginLeft: "20px",
                }}
              >
                <div
                  // className="label-textfield"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    marginTop: "10px",
                    paddingLeft: "15px",
                  }}
                >
                  End Of Shift
                </div>

                <DatePickerWithTimeComponentNoTitle
                  value={shiftEndRaw}
                  onChange={(date) => setShiftEndRaw(date)}
                  title="End Of Shift"
                  error={!!errors.shiftEndRaw}
                  helperText={errors.shiftEndRaw}
                />
              </div>
            </div>
            <div
              // className="line3-modal-mobile-bis"
              style={{ paddingLeft: "20px", marginTop: "20px" }}
            >
              <div
                // className="label-textfield"
                style={{
                  color: "black",
                  fontWeight: "600",
                  marginTop: "10px",
                  paddingLeft: "5px",
                }}
              >
                Select Staff
              </div>
              <div style={{ width: "50%" }}>
                <DropDownSpecificStaffV2
                  value={selectedStaff}
                  onChange={(staff) => setSelectedStaff(staff)}
                  error={!!errors.selectedStaff}
                  helperText={errors.selectedStaff}
                  // title={translate("SelectStaff")}
                />
              </div>
            </div>

            <div style={{ paddingLeft: "10px", marginTop: "20px" }}>
              <div
                className="label-textfield-handover"
                style={{
                  color: "black",
                  fontWeight: "600",
                  paddingLeft: "10px",
                }}
              >
                Effective Date Time
              </div>
              <div style={{ paddingLeft: "5px" }}>
                <DatePickerWithTimeComponentNoTitle
                  value={effectiveDateTime}
                  onChange={(date) => setEffectiveDateTime(date)}
                  title="Effective Date Time"
                  error={!!errors.effectiveDateTime}
                  helperText={errors.effectiveDateTime}
                />
              </div>
            </div>
          </div>
        );

      case "familyNote":
        return (
          <div>
            {renderClientSection()}
            <div
              style={{
                width: "100%",
                marginTop: "0px",
                height: "75%",
                overflowY: "scroll",
                overflowX: "hidden",
              }}
            >
              {renderNoteContent("Type family session note here", 14)}
              {renderEffectiveDateTime()}
              <div className="main-upload-container">
                <UploaderDocForNoteV2
                  handleFileChange={handleFilesChange}
                  files={files}
                  handleFileRemove={handleFileRemove}
                />
              </div>
            </div>
          </div>
        );

      case "aftercareNote":
      case "quickNote":
      case "therapyNote":
        return (
          <div>
            {renderClientSection()}
            <div
              style={{
                width: "100%",
                marginTop: "0px",
                height: "75%",
                overflowY: "scroll",
                overflowX: "hidden",
              }}
            >
              {renderNoteContent("Type quick session note here", 14)}
              {renderEffectiveDateTime()}
            </div>
          </div>
        );

      case "groupNote":
        return (
          <div style={{ marginBottom: "30px" }}>
            {/* {renderClientSection()} */}
            <div className="inputAndLabelModalContainerTitle2">
              <div style={{ paddingLeft: "10px", paddingRight: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: "20px",
                    marginBottom: "0px",
                  }}
                >
                  <div
                    className="label-textfield-handover"
                    style={{
                      color: "black",
                      fontWeight: "600",
                      paddingLeft: "10px",
                      paddingBottom: "5px",
                    }}
                  >
                    Group Topic
                  </div>
                  <div style={{ marginLeft: "15px" }}>
                    {/* <TextField
                      variant="outlined"
                      onChange={(e) => setGroupTopic(e.target.value)}
                      value={groupTopic}
                      style={{
                        width: "300px",
                        height: "30px",
                        borderRadius: "5px",
                        background: "#FFFFFF",
                        // border: "1px solid #BEBCBC",
                        marginTop: "2px",
                        paddingLeft: "0px",
                      }}
                      error={!!errors.groupTopic}
                      helperText={errors.groupTopic}
                    /> */}
                    <TextField
                      variant="outlined"
                      onChange={(e) => setGroupTopic(e.target.value)}
                      value={groupTopic}
                      style={{
                        width: "300px",
                        marginTop: "2px",
                      }}
                      error={!!errors.groupTopic}
                      helperText={errors.groupTopic}
                      InputProps={{
                        style: {
                          height: "40px", // Applique la hauteur ici
                          padding: "0 10px", // Ajuste le padding si nécessaire
                          boxSizing: "border-box", // S'assure que la hauteur inclut le padding
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingTop: "20px",
                  width: "100%",
                }}
              >
                <div
                  // className="line3-modal"
                  style={{
                    paddingLeft: "25px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignContent: "start",
                    width: "100%",
                    paddingBottom: "0px",
                  }}
                >
                  <div
                    // className="label-textfield-handover"
                    style={{
                      color: "black",
                      fontWeight: "600",
                      marginTop: "10px",
                    }}
                  >
                    Group Date Start Time
                  </div>
                  <div
                    style={{
                      paddingTop: "10px",
                      width: "100%",
                      paddingLeft: "0px",
                    }}
                  >
                    <DatePickerWithTimeComponentNoTitleNoMargin
                      isRequired={true}
                      value={effectiveDateTime}
                      title="Group Date and start time"
                      width="400px"
                      onChange={(date) => setEffectiveDateTime(date)}
                      leftMargin="none"
                      error={!!errors.effectiveDateTime}
                      helperText={errors.effectiveDateTime}
                    />
                  </div>
                </div>
                <div
                  style={{
                    paddingLeft: "15px",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    marginTop: "10px",
                    marginBottom: "20px",
                  }}
                >
                  <div
                    className="label-textfield-handover"
                    style={{
                      color: "black",
                      fontWeight: "600",
                      marginTop: "20px",
                      paddingLeft: "10px",
                    }}
                  >
                    Type Of Group
                  </div>
                  <div style={{ width: "40%" }}>
                    <DropDownComponentSortedNoTitle
                      isRequired={true}
                      api="groupType"
                      title="Type of group"
                      value={groupType}
                      onChange={(type) => setGroupType(type)}
                      error={!!errors.groupType}
                      helperText={errors.groupType}
                    />
                    {groupType === "Other" && (
                      <div style={{ marginTop: "10px", marginLeft: "10px" }}>
                        <InputComponentNoTitleNomargin
                          title="If Other Describe"
                          width="auto"
                          value={otherTypeGroupNote}
                          onChange={(e) => setOtherTypeGroupNote(e)}
                          placeholder="If Other Describe"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {renderNoteContent("TypeGroupNoteHere", 10)}
              <div className="line2-column-modal">
                <div
                  className="label-textfield"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    paddingLeft: "0px",
                    paddingBottom: "5px",
                  }}
                >
                  Clients Not In Attendance
                  <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
                </div>
                <TextField
                  style={{ width: "95%", borderRadius: "5px" }}
                  placeholder="Type Names And Reason"
                  multiline
                  rows={4}
                  value={notInAttendance}
                  onChange={(e) => setNotInAttendance(e.target.value)}
                  error={!!errors.notInAttendance}
                  helperText={errors.notInAttendance}
                />
              </div>
            </div>
          </div>
        );

      case "handoverNote":
        return (
          <div>
            <div
              style={{
                width: "100%",
                marginTop: "0px",
                height: "75%",
                overflowX: "hidden",
              }}
            >
              <div className="line2-column-modal-handover">
                <div
                  className="tab-form-container-handover"
                  style={{ marginTop: "0px" }}
                >
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      Immigration Appointment
                    </div>
                    <TextField
                      value={immmigrationAppointment}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) =>
                        setImmigrationAppointment(e.target.value)
                      }
                      error={!!errors.immigrationAppointment}
                      helperText={errors.immigrationAppointment}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      Discharges Flights
                    </div>
                    <TextField
                      value={dischargesSwot}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setDischargeSwot(e.target.value)}
                      error={!!errors.dischargesSwot}
                      helperText={errors.dischargesSwot}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      New Clients
                    </div>
                    <TextField
                      value={newClients}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setNewClients(e.target.value)}
                      error={!!errors.newClients}
                      helperText={errors.newClients}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      Psychiatrist Appointments
                    </div>
                    <TextField
                      value={medicalInfos}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setMedicalInfos(e.target.value)}
                      error={!!errors.medicalInfos}
                      helperText={errors.medicalInfos}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      Hospital Appointments
                    </div>
                    <TextField
                      value={hospitalAppointment}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setHospitalAppointment(e.target.value)}
                      error={!!errors.hospitalAppointment}
                      helperText={errors.hospitalAppointment}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      Outings
                    </div>
                    <TextField
                      value={residentialClientMovements}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) =>
                        setResidentialClientMovements(e.target.value)
                      }
                      error={!!errors.residentialClientMovements}
                      helperText={errors.residentialClientMovements}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      Zoom Session Assistance
                    </div>
                    <TextField
                      value={zoomSessionAssistance}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setZoomSessionAssistance(e.target.value)}
                      error={!!errors.zoomSessionAssistance}
                      helperText={errors.zoomSessionAssistance}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      Staff Today
                    </div>
                    <TextField
                      value={staffToday}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setStaffToday(e.target.value)}
                      error={!!errors.staffToday}
                      helperText={errors.staffToday}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      Overnight
                    </div>
                    <TextField
                      value={overnight}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setOvernight(e.target.value)}
                      error={!!errors.overnight}
                      helperText={errors.overnight}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      Number Of Clients
                    </div>
                    <TextField
                      value={numberOfClient}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setNumberOfClient(e.target.value)}
                      error={!!errors.numberOfClient}
                      helperText={errors.numberOfClient}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div
                    className="textfield-and-label-container100"
                    style={{ marginBottom: "10px" }}
                  >
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      Swot
                    </div>
                    <TextField
                      value={swot}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setSwot(e.target.value)}
                      error={!!errors.swot}
                      helperText={errors.swot}
                    />
                  </div>
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      General Announcement
                    </div>
                    <TextField
                      value={generalAnnouncement}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="Type Note Here"
                      multiline
                      rows={5}
                      onChange={(e) => setGeneralAnnouncement(e.target.value)}
                      error={!!errors.generalAnnouncement}
                      helperText={errors.generalAnnouncement}
                    />
                  </div>
                </div>
              </div>
              <div
                style={{
                  paddingLeft: "10px",
                  marginTop: "15px",
                  marginBottom: "40px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                }}
              >
                <div
                  className="label-textfield-handover"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    paddingLeft: "10px",
                  }}
                >
                  Effective Date Time
                </div>
                <div style={{ paddingLeft: "5px" }}>
                  <DatePickerWithTimeComponentNoTitle
                    value={effectiveDateTime}
                    onChange={(date) => setEffectiveDateTime(date)}
                    title="EffectiveDateTime"
                    error={!!errors.effectiveDateTime}
                    helperText={errors.effectiveDateTime}
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case "medicalNote":
        return (
          <div>
            {renderClientSection()}
            <div className="line2-column-modal">
              <div
                className="label-textfield-handover"
                style={{
                  color: "black",
                  fontWeight: "600",
                  paddingLeft: "15px",
                  paddingBottom: "5px",
                }}
              >
                Note Content
              </div>
              <TextField
                name="quickNote"
                value={noteContent}
                onChange={(e) => setNoteContent(e.target.value)}
                style={{
                  width: "95%",
                  borderRadius: "5px",
                }}
                placeholder="Type Note Here"
                multiline
                rows={14}
                error={!!errors.noteContent} // Highlight the input if there's an error
                helperText={errors.noteContent}
              />
            </div>
            <div
              style={{
                display: "flex",
                width: "50%",
                flexDirection: "column",
              }}
            >
              <div
                className="label-textfield-handover"
                style={{
                  color: "black",
                  fontWeight: "600",
                  marginTop: "20px",
                  paddingLeft: "20px",
                  paddingBottom: "5px",
                  width: "350px",
                }}
              >
                Effective Date Time"
              </div>
              <div style={{ paddingLeft: "15px" }}>
                <DatePickerWithTimeComponentNoTitle
                  title="Effective Date Time"
                  value={effectiveDateTime}
                  onChange={(date) => setEffectiveDateTime(date)}
                  error={!!errors.effectiveDateTime}
                  helperText={errors.effectiveDateTime}
                />
              </div>
            </div>
            <div className="main-upload-container">
              <UploaderDocForNoteV2
                handleFileChange={handleFilesChange}
                files={files}
                handleFileRemove={handleFileRemove}
              />
              {/* {fileUrls.length > 0 && (
                <UploadedFilesComponentV2
                  fileLinks={fileUrls}
                  deleteFile={(fileUrl, fileName) =>
                    handleFileRemove(fileUrl, fileName, noteId)
                  }
                  noteId={noteId}
                />
              )} */}
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  const handleSaveNote = async () => {
    if (!validateFields()) {
      return;
    }

    setIsLoading(true);
    const shiftStart = shiftStartRaw;
    const shiftEnd = shiftEndRaw;

    try {
      const currentUserEmail = currentUser
        ? currentUser.displayName
        : "Unknown";

      // Créez d'abord la note sans les fichiers
      const newNoteRef = await addDoc(collection(db, "notes"), {
        noteType,
        noteContent,
        effectiveDateTime,
        createdAt: new Date(),
        updatedAt: new Date(),
        doneBy: currentUserEmail,
        updateBy: currentUserEmail,
        ...(noteType === "handoverNote" && {
          generalAnnouncement,
          immmigrationAppointment,
          dischargesSwot,
          newClients,
          medicalInfos,
          hospitalAppointment,
          residentialClientMovements,
          zoomSessionAssistance,
          staffToday,
          overnight,
          numberOfClient,
          swot,
        }),
        ...(noteType === "groupNote" && {
          groupTopic,
          groupType,
          notInAttendance,
          otherTypeGroupNote,
        }),
        ...(noteType !== "handoverNote" &&
          noteType !== "groupNote" &&
          selectedClient && {
            clientId: selectedClient.id,
            clientFirstName: selectedClient.firstName,
            clientLastName: selectedClient.lastName,
            ...(selectedClient.profilePicture && {
              clientProfilePicture: selectedClient.profilePicture,
            }),
          }),
        ...(noteType === "endOfShift" && {
          shiftStart,
          shiftEnd,
          staff: selectedStaff,
        }),
      });

      // Utilisez l'ID de la note pour sauvegarder les fichiers
      const fileUrls =
        files.length > 0
          ? await Promise.all(
              files.map(async (file) => {
                const storage = getStorage();
                const filePath = `Documents/${
                  noteType === "medicalNote"
                    ? "medicalNotes"
                    : noteType === "familyNote"
                    ? "familyNotes"
                    : "otherNotes"
                }/${newNoteRef.id}/${file.name}`;

                const storageRef = ref(storage, filePath);
                await uploadBytes(storageRef, file);
                const downloadUrl = await getDownloadURL(storageRef);
                console.log("Document uploaded to:", downloadUrl);
                return { url: downloadUrl, name: file.name };
              })
            )
          : [];

      // Mettez à jour la note avec les URLs des fichiers
      await updateDoc(newNoteRef, { fileUrls });

      console.log("Note ID:", newNoteRef.id);
      onClose();
      showCustomToast("NoteAddedSuccess", "success");
    } catch (error) {
      console.error("Error saving note:", error);
      showCustomToast("Problem when saving note!", "error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!open) {
      resetForm();
    }
  }, [open]);

  const resetForm = () => {
    setNoteContent("");
    setEffectiveDateTime(null);
    setFiles([]);
    setShiftStartRaw(null);
    setShiftEndRaw(null);
    setSelectedStaff("");
    setGroupTopic("");
    setGroupType("");
    setOtherTypeGroupNote("");
    setNotInAttendance("");
    setImmigrationAppointment("");
    setDischargeSwot("");
    setNewClients("");
    setMedicalInfos("");
    setHospitalAppointment("");
    setResidentialClientMovements("");
    setZoomSessionAssistance("");
    setStaffToday("");
    setOvernight("");
    setNumberOfClient("");
    setSwot("");
    setGeneralAnnouncement("");
    setSelectedClient(null);
    setErrors({});
  };

  const formatNoteType = (noteType) => {
    return noteType
      .replace(/([A-Z])/g, " $1") // Add space before capital letters
      .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="note-modal-title"
      aria-describedby="note-modal-description"
      closeAfterTransition
    >
      <Slide direction="left" in={open}>
        <Box
          sx={{
            position: "fixed",
            top: "5%",
            right: 0,
            width: isMobile ? "90%" : "30%",
            height: "90%",
            bgcolor: "background.paper",
            boxShadow: 24,
            marginRight: "15px",
            pl: 0,
            pr: 0,
            borderRadius: "15px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
              borderBottom: "1px solid lightgray",
            }}
          >
            <div
              id="note-modal-title"
              style={{
                margin: 0,
                paddingLeft: "35px",
                paddingTop: "10px",
                paddingBottom: "10px",
                fontSize: "22px",
                fontWeight: "700",
              }}
            >
              {`Add ${formatNoteType(noteType)}`}
            </div>
            <div style={{ paddingRight: "15px" }}>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </div>
          </Box>
          {/* <Box
            id="note-modal-description"
            sx={{ flexGrow: 1, overflowY: "auto", mt: 0, pl: 2, pr: 2 }}
          >
            
            {renderModalContent(
              noteType,
              [
                "aftercareNote",
                "familyNote",
                "quickNote",
                "therapyNote",
                "medicalNote",
              ].includes(noteType)
            )}
          </Box> */}
          <Box
            id="note-modal-description"
            sx={{ flexGrow: 1, overflowY: "auto", mt: 0, pl: 2, pr: 2 }}
          >
            {renderModalContent(
              noteType,
              [
                "aftercareNote",
                "medicalNote",
                "familyNote",
                "quickNote",
                "supportStaffNote",
                "therapyNote",
              ].includes(noteType)
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              borderTop: "1px solid lightgray",
              padding: "10px 20px",
              mt: "auto",
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              style={{ marginRight: "10px" }}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveNote}
              disabled={isLoading}
            >
              {isLoading ? <CircularProgress size={24} /> : "Save"}
            </Button>
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
};

export default NotesAddModal;
